<template>
	<div class="warn-tables environ-table" v-loading="loading">
		<div v-if="tableData.length">
			<el-table
				:data="tableData"
				class="tables"
				:height="535"
				:stripe="true"
				align="center"
				header-cell-class-name="header-cell"
				cell-class-name="table-cell"
			>
				<el-table-column
					prop="acquisitionTime"
					label="时间"
					align="center"
					show-overflow-tooltip
				>
				</el-table-column>
				<!-- 动态显示类型 -->
				<el-table-column
					:label="item"
					align="center"
					show-overflow-tooltip
					v-for="(item, index) in tableCTypes"
					:key="index"
				>
					<template slot-scope="scope">
						<span
							v-if="
								scope.row.tableList[item] &&
								scope.row.tableList[item] >= 0
							"
							>{{ scope.row.tableList[item] }}</span
						>
						<span v-else>--</span>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination
				class="pagination"
				layout="prev, pager, next"
				:current-page.sync="ipagination.currentPage"
				:page-size="ipagination.pageSize"
				:total="ipagination.total"
				:hide-on-single-page="true"
				@current-change="handleCurrentChange"
			>
			</el-pagination>
		</div>
		<!-- 暂无数据 -->
		<div class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty" v-else>
			<img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
			<div class="table-emptyword">暂无数据</div>
		</div>
	</div>
</template>

<script>
/**
 * @description 统计报表
 */
import tableMinin from '@/mixins/TableMinin'
export default {
	mixins: [tableMinin],
	data() {
		return {
			// 表格数据
			queryParam: {},
			// queryParam: {
			// 	orgId: '1484801122776784897',
			// 	startTime: '2022-04-05 00:00:00',
			// 	sensorCode: '1',
			// 	endTime: '2022-04-14 23:59:59',
			// },
			isTranPage: true,
			pageValue: 'currentPage',
			disableMixinCreated: true,
			isFillTime: false,
			ifUseLoadBack: false,
			tableCTypes: [],
			url: {
				list: '/napi/index/areaEnvStatisticsReport',
			},
		}
	},
	// props: {
	// 	queryParams: {
	// 		type: Object,
	// 		default: () => {
	// 			return {}
	// 		},
	// 	},
	// },
	// watch: {
	// 	queryParams: {
	// 		deep: true,
	// 		handler(val) {
	// 			console.log(val)
	// 			this.queryParam = val
	// 		},
	// 	},
	// },
	mounted() {
		// setTimeout(() => {
		// 	this.loadData()
		// }, 200)
	},
	methods: {
		set(val) {
			this.queryParam = JSON.parse(JSON.stringify(val))
		},
		loadBack(res) {
			let result = res.data
			let datas = JSON.parse(JSON.stringify(res.data.content))

			// 类型处理  ---- start

			if (!datas.length) {
				this.tableData = []
				this.tableCTypes = []
				this.isLine = false
				return
			}
			this.isLine = true

			if (result.totalElements) {
				this.ipagination.total = Number(result.totalElements)
				this.ipagination.pageSize = result.size
			} else {
				this.ipagination.total = 0
				this.ipagination.pageSize = 10
			}
			let lenData = [] //类型数组
			// 类型处理  ---- start
			datas.forEach((item, index) => {
				let tableList = {}
				let sensorCode = this.queryParam.sensorCode
				let keyIndex = ''
				for (const i in item.sensorDataMap) {
					if (item.sensorDataMap[i][0]['sensorCode'] == sensorCode) {
						keyIndex = i
						break
					}
				}
				item.sensorDataMap[keyIndex].forEach((key, ind) => {
					let lenIndex = lenData.findIndex((kk) => {
						return (
							kk ==
							`${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
						)
					})
					if (lenIndex > -1) {
					} else {
						lenData.push(
							`${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
						)
					}
					tableList[
						`${key.acquisitionItemName}(${key.acquisitionItemUnitCode})`
					] = key.acquisitionData || 0
				})
				item.tableList = tableList
			})
			this.tableCTypes = lenData
			// 类型处理  ---- end
			// 表格数据赋值
			this.tableData = datas
			console.log(this.tableData)
		},
		hideLoad() {
			this.loading = false
		},
	},
}
</script>

<style lang="scss" scoped>
.environ-table {
	margin-top: 0.25rem;
	border-radius: 0;
	.bottom-empty {
		line-height: 1.3;
		// height: 8rem;
		margin-top: 2.49rem;
		.table-noimg {
			height: 2.4rem;
		}
	}
}
</style>
